export const WHEN_TO_USE = `Apply explicitly requested
configuration to the view that is currently open.

Use this command when the user asks to:
- change a configuration option of the open view;

Settings can only be applied to the open view, named by 'currentView'. This
command never opens or switches views. If the settings belong to a different
view, call the changeView command first and apply the settings in a later call.

Use 'settings' for configuration options explicitly requested by the user and
supported by the open view.`;

export const CHANGE_VIEW_SETTINGS_CONTEXT_DESCRIPTION = `'currentView' — the enum id of the
currently open view, or null if no view is open.

'currentSettings' — the current values of all AI-changeable settings for the
currently open view only.

'viewState' — live, non-persistent information and data-dependent capabilities
of the currently open view, keyed by view. It is present only when the relevant
live state is available. It is informational context, not settings: never emit
its keys in 'settings'. Each setting whose bounds it carries says so in its own
description; honour the 'canSet...' flag before including that setting, and keep
values within the listed names, ranges and entries. While it is absent those
bounds are unknown: apply the settings that do not draw on one of its lists and
ask about the rest.

- Emit only values present in the matching list.
- Where a list holds objects rather than names, copy an entry as it is given.
- If what the user asks for is not listed, apply the rest and ask what they meant
  rather than guessing.
- Each list describes the view as configured now. Do not change a setting and set
  the values its list constrains in the same call: change it, set them next.
`;
